<!--child.vue-->
<template>
  <div class="tips_wrap">
    <el-dialog
      title=""
      :visible.sync="dialogFormVisible"
      @close="closeDialog"
      width="60%"
      :close-on-click-modal="false"
    >
      <div slot="title" class="header-title">
        <span class="title-name">
          <span v-if="!ischeck">新增入住</span>
          <span v-if="ischeck">当前入住信息</span>
          {{ this.checkOrder.homeTypeName }}{{ checkOrder.homeNum }}
          <span v-if="ischeck">办理入住时间:{{ checkOrder.createTime }}</span>
          <span v-if="ischeck"> 订单编号:{{ checkOrder.id }}</span>
        </span>
      </div>

      <el-descriptions title="" :column="2" border v-loading="loading">
        <el-descriptions-item label="入住人姓名">
          <el-input
            size="medium"
            clearable
            placeholder="请输入登记人姓名"
            v-model="checkOrder.checkPersonName"
            autocomplete="off"
          ></el-input>
          <div>{{ vipInfo }}</div>
        </el-descriptions-item>
        <el-descriptions-item v-if="!ischeck" label="会员查询">
          <div style="display: flex">
            <el-input
              clearable
              placeholder="输入手机号查询"
              v-model="checkOrder.checkPersonPhone"
              autocomplete="off"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getVip"
              ></el-button>
            </el-input>
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="当前房间单价">
          {{ this.checkOrder.homePrice }}/天 房费小计:￥{{
            (this.checkOrder.startDays + this.checkOrder.continued) *
            this.checkOrder.homePrice
          }}
        </el-descriptions-item>

        <el-descriptions-item label="房费情况" v-if="ischeck">
          已交:{{ this.checkOrder.homePriceCost }} 当前余额:{{
          this.checkOrder.homePriceCost-  (this.checkOrder.startDays + this.checkOrder.continued) *
              this.checkOrder.homePrice 
          }}
          
        </el-descriptions-item>

        <el-descriptions-item label="预订单" v-if="!ischeck">
          <el-select
            v-model="checkOrder.isSchedule"
            :disabled="isSchedule"
            placeholder="请选择"
          >
            <el-option
              v-for="item in yd"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>

        <el-descriptions-item label="入住日期">
          <div>
            <el-date-picker
              :disabled="ischeck"
              v-model="value1"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="入住日期"
              end-placeholder="退房日期"
              @change="timeChange"
            >
              
            </el-date-picker>
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="入住天数">
          <div>
            入住天数:{{ checkOrder.startDays + checkOrder.continued }}天
          </div>
          <div v-if="ischeck">
            {{ checkOrder.startDays }}+{{ checkOrder.continued }}(续住)
          </div>
        </el-descriptions-item>

        <el-descriptions-item label="房间押金">
          ￥{{ checkOrder.homeDeposit }}
        </el-descriptions-item>

        <el-descriptions-item label="押金消费" v-if="ischeck">
          <el-input
            size="medium"
            clearable
            placeholder=""
            v-model="checkOrder.depositCost"
            autocomplete="off"
          ></el-input>
        </el-descriptions-item>

        <el-descriptions-item label="押金结余" v-if="ischeck">
          ￥{{ returnMoney }}
        </el-descriptions-item>
      </el-descriptions>

      <div slot="footer" class="dialog-footer">
        <div v-if="!ischeck">
          <el-button type="primary" @click="submitForm('checkOrder')"
            >确认办理</el-button
          >
        </div>

        <div v-if="ischeck&&!loading">
          <button @click="showlog">操作记录</button>
          <button
            @click="ddConfirm"
            v-if="checkOrder.isSchedule == 1 && checkOrder.isArrive == 0"
          >
            预约到店
          </button>
          <button
            @click="qxyyConfirm"
            v-if="checkOrder.isSchedule == 1 && checkOrder.isArrive == 0"
          >
            取消预约
          </button>
          <button @click="xzshow = true">续住</button>
          <button @click="czshow = true">房费充值</button>
          <button @click="tfDelfirm">退房</button>
        </div>
      </div>
    </el-dialog>

    <div>
      <el-dialog
        title="续住"
        :visible.sync="xzshow"
        @close="xzcloseDialog"
        :close-on-click-modal="false"
      >
        <div>
          <el-select
            v-model="xzFrom.continued"
            placeholder="请选择入住时长(天)"
          >
            <el-option
              v-for="item in xzoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div style="margin-top: 10px">
            当前房间截止时间：{{ formatDate(checkOrder.timeStart) }}至{{
              formatDate(checkOrder.timeEnd)
            }}
          </div>
          <div style="margin-top: 10px">
            当前已续住：{{ checkOrder.continued }}天
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="xz()">确认续住</el-button>
          </div>
        </div>
      </el-dialog>
    </div>

    <div>
      <el-dialog
        title=""
        :visible.sync="czshow"
        @close="czcloseDialog"
        :close-on-click-modal="false"
      >
        <div slot="title" class="header-title">
          <span class="title-name"
            >房费充值 当前房费{{ checkOrder.homePrice }}/天</span
          >
          <span>
            还需充值￥{{
              (this.checkOrder.startDays + this.checkOrder.continued) *
                this.checkOrder.homePrice -
              checkOrder.homePriceCost
            }}</span
          >
        </div>
        <el-input
          type="number"
          v-model="ffFrom.homePriceCost"
          autocomplete="off"
          placeholder="请输入充值金额(元)"
        ></el-input>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="ffcz">确定充值</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog title="订单操作记录" :visible.sync="recordShow">
        <div v-if="noLog">暂无记录</div>
        <el-timeline :reverse="false">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.createTime"
          >
            <div style="display: flex">
              <div>{{ activity.logTypeName }}</div>
              <div style="font-size: 12px; margin-left: 5px; color: blue">
                {{ activity.remake }}
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: "checkOrderDetail",
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log("我是子组件");
  },

  data() {
    return {
      recordShow: false,
      vipInfo: "",
      xzshow: false,
      tfshow: false,
      czshow: false,

      ffFrom: {
        id: "",
        homePriceCost: "",
      },
      xzFrom: {
        id: "",
        continued: 1,
      },
      yd: [
        {
          value: 0,
          label: "否",
        },
        {
          value: 1,
          label: "是",
        },
      ],
      xzoptions: [
        {
          value: 1,
          label: "1天",
        },
        {
          value: 2,
          label: "2天",
        },
        {
          value: 3,
          label: "3天",
        },
        {
          value: 4,
          label: "4天",
        },
        {
          value: 5,
          label: "5天",
        },
      ],
      noLog: false,
      value1: "",
      load2: false,
      loading: false,
      isSchedule: false,
      ischeck: false,
      formLabelWidth: "100px",
      dialogFormVisible: this.dialogShow,
      from: {
        id: "",
        continued: "",
        homePrice: "",
      },
      backTime: "",
      checkOrder: {
        checkPersonPhone: "",
        checkPersonName: "",
        homeTypeName: "",
        homePrice: 0,
        homeId: "",
        homeNum: "",
        homeDeposit: "",
        isSchedule: 0,
        startDays: 1,
        continued: 0,
        homePriceCost: 0,
      },
      activities: [],
      rules: {
        checkPersonName: [
          { required: true, message: "请输入预定人姓名", trigger: "blur" },
          { min: 2, max: 4, message: "长度在 2 到 4 个字符", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {},
  computed: {
    returnMoney() {
      return this.checkOrder.homeDeposit - this.checkOrder.depositCost;
    },
    totalMoney() {
      // var all=(this.checkOrder.startDays+this.checkOrder.continued)*this.checkOrder.homePrice
      // this.checkOrder.homePriceCost=all
      // console.log("房间金额改变"+all+this.checkOrder.homePriceCost)
      return (
        (this.checkOrder.startDays + this.checkOrder.continued) *
        this.checkOrder.homePrice
      );
    },
  },
  created() {},
  watch: {
    dialogShow(val) {
      this.dialogFormVisible = val;
    },
  },
  methods: {
    showlog() {
      this.recordShow = true;
      var that = this;
      that.noLog = true;
      that.$axios
        .get("/api2/business/getCheckOrderLog/" + this.checkOrder.id, {})
        .then(function (response) {
          if (response.data.data.length!=0) {
            that.activities = response.data.data;
            that.noLog = false;
          } else {
            console.log("无房间日志")
            that.noLog = true;
          }
        });
    },

    tf() {
      const loading = this.$loading({
        lock: true,
        text: "办理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      var that = this;
      that.ffFrom.id = this.checkOrder.id;
      that.$axios
        .post("/api2/business/updateCheckOrder", {
          id: that.checkOrder.id,
          depositCost: that.checkOrder.depositCost,
          depositRefund:
            that.checkOrder.homeDeposit - that.checkOrder.depositCost,
          isEnd: 1,
        })
        .then(function (response) {
          console.log(response.data.code);
          loading.close();
          if (response.data.code == 200) {
            that.$notify({
              title: "成功",
              message: "办理成功",
              type: "success",
            });
          } else {
            that.$notify.error({
              title: "失败",
              message: response.data.msg,
            });
          }

          that.czshow = false;
          that.$emit("pushdata");
          that.$emit("modelShowChange", false);
        });
    },

    ffcz() {
      const loading = this.$loading({
        lock: true,
        text: "办理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var that = this;
      that.ffFrom.id = this.checkOrder.id;
      that.$axios
        .post("/api2/business/updateCheckOrder", that.ffFrom)
        .then(function (response) {
          console.log(response.data.code);
          that.$message({
            type: "success",
            message: "操作成功",
          });
          that.czshow = false;
          that.pushdata();
          loading.close();
        });
    },

    submitForm(checkOrder) {
      if (this.checkOrder.checkPersonName == "") {
        this.$message({
          type: "error",
          message: "请填写入住人姓名",
        });
      } else {
        this.addDelfirm();
      }
    },
    dd() {
      const loading = this.$loading({
        lock: true,
        text: "办理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var that = this;
      that.$axios
        .post("/api2/business/updateCheckOrder", {
          id: that.checkOrder.id,
          isArrive: 1,
        })
        .then(function (response) {
          console.log(response.data.code);
          that.$message({
            type: "success",
            message: "操作成功",
          });
          that.czshow = false;
          that.$emit("pushdata");
          that.pushdata();
          loading.close();
        });
    },

    ddConfirm() {
      this.$confirm("确认到店?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.dd();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    qxyy() {
      const loading = this.$loading({
        lock: true,
        text: "办理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var that = this;
      that.$axios
        .post("/api2/business/updateCheckOrder", {
          id: that.checkOrder.id,
          isDelete: 1,
        })
        .then(function (response) {
          console.log(response.data.code);
          that.$message({
            type: "success",
            message: "操作成功",
          });
          that.czshow = false;
          loading.close();
          that.$emit("pushdata");
          that.$emit("modelShowChange", false);
        });
    },
    qxyyConfirm() {
      this.$confirm("确认取消该预约订单?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.qxyy();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    tfDelfirm() {
      this.$confirm(
        "当前房费共:" +
          (this.checkOrder.startDays + this.checkOrder.continued) *
            this.checkOrder.homePrice +
          "元 实缴房费 " +
          this.checkOrder.homePriceCost +
          // " 房费欠余 "+   (this.checkOrder.startDays+this.checkOrder.continued)*this.checkOrder.homePrice-this.checkOrder.homePriceCost+
          " 实缴押金:" +
          this.checkOrder.homeDeposit +
          "元 押金消费:" +
          this.checkOrder.depositCost +
          "元 应退还押金:" +
          this.returnMoney,
        "是否确认退房?",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.tf();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    getDayName(d){
		   var td=new Date();
		   td=new Date(td.getFullYear(),td.getMonth(),td.getDate());
		   var od=new Date(d);
		   od=new Date(od.getFullYear(),od.getMonth(),od.getDate());
		   var xc=(od-td)/1000/60/60/24;
		   if(xc<-2){
		      return -xc+"天前";
		   }else if(xc<-1){
		      return "前天";
		   }else if(xc<0){
		      return "昨天";
		   }else if(xc==0){
		      return "今天";
		   }else if(xc<2){
		      return "明天";
		   }else if(xc<3){
		      return "后天";
		   }else{
		      return xc+"天后";
		   }
		},

    returnTime() {
      this.backTime =
        this.formatDate(this.value1[0]) +
        "至" +
        this.formatDate(this.value1[1]) +
        " 14:00";
    },
    addDelfirm() {
      this.returnTime();
      this.$confirm(
        "入住人: " +
          this.checkOrder.checkPersonName +
          " 入住时间:" + this.value1[0]+"("+this.getDayName(this.value1[0])+")"+"至"
        +this.value1[1]+"("+this.getDayName(this.value1[1])+")"+
        " 是否确认入住?",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.addCheckOrder();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    timeChange() {
      console.log("重新选择时间");
      this.getTimeDays();


    },

    getDiffDay(date_1, date_2) {
      // 计算两个日期之间的差值
      let totalDays, diffDate;
      let myDate_1 = Date.parse(date_1);
      let myDate_2 = Date.parse(date_2);
      // 将两个日期都转换为毫秒格式，然后做差
      diffDate = Math.abs(myDate_1 - myDate_2); // 取相差毫秒数的绝对值

      totalDays = Math.floor(diffDate / (1000 * 3600 * 24)); // 向下取整
      // console.log(totalDays)

      return totalDays; // 相差的天数
    },
    //续住
    xz() {
      const loading = this.$loading({
        lock: true,
        text: "办理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var that = this;
      that.xzFrom.id = this.checkOrder.id;
      that.$axios
        .post("/api2/business/updateCheckOrder", that.xzFrom)
        .then(function (response) {
          console.log(response.data.code);
          that.$message({
            type: "success",
            message: "操作成功",
          });
          that.xzshow = false;
          that.pushdata();
          // that.$emit("pushdata");
          loading.close();
        });
    },

    getTimeDays() {
      var time0 = this.formatDate(this.formatDate(this.value1[0]));
      var time1 = this.formatDate(this.formatDate(this.value1[1]));

      var diff = this.getDiffDay(time1, time0);
      if (diff <= 1) {
        this.checkOrder.startDays = 1;
      } else {
        this.checkOrder.startDays = diff;
      }
    },
    getVip() {
      if (!this.checkOrder.checkPersonPhone) {
        this.$message({
          type: "info",
          message: "请输入手机号",
        });
        return;
      }
      var that = this;
      that.$axios
        .post("/api2/business/getCustom", {
          customPhone: that.checkOrder.checkPersonPhone,
        })
        .then(function (response) {
          console.log(response.data.code);

          if (response.data.code == 200) {
            that.vipInfo = "当前余额:" + response.data.data.customMoney;
            that.checkOrder.checkPersonName = response.data.data.customName;
          } else {
            that.vipInfo = "会员不存在!";
          }
        });
    },
    homeInfo(item) {
      console.log(item);
      var that = this;
      that.checkOrder.homeId = item.id;
      that.checkOrder.isSchedule = 0;

      if (item.checkPersonName) {
        that.loading = true;
        that.ischeck = true;
        that.$axios
          .get("/api2/business/getCheckOrderInfo/" + that.checkOrder.homeId, {})
          .then(function (response) {
            that.checkOrder = response.data.data;
            that.value1 = [that.checkOrder.timeStart, that.checkOrder.timeEnd];
            that.loading = false;
            that.isSchedule = true;
          });
      } else {
        that.checkOrder.checkPersonName = "";
        that.ischeck = false;
        that.isSchedule = false;
      }
     // that.checkOrder.homeTypeName = item.homeTypeName;
      that.checkOrder.homeNum = item.homeNum;
      that.checkOrder.homePrice = item.homePrice;
      that.checkOrder.homeDeposit = item.homeDeposit;
      that.value1 = [item.time, item.time];
    },
    addCheckOrder() {
      const loading = this.$loading({
        lock: true,
        text: "办理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var that = this;
      that.checkOrder.timeStart = that.value1[0];
      that.checkOrder.timeEnd = that.value1[1];
      that.checkOrder.homePriceCost =
        (this.checkOrder.startDays + this.checkOrder.continued) *
        this.checkOrder.homePrice;
      that.$axios
        .post("/api2/business/addCheckOrder", that.checkOrder)
        .then(function (response) {
          loading.close();
          that.$notify({
            title: "成功",
            message: "办理成功",
            type: "success",
          });
          that.$emit("pushdata");
          that.$emit("modelShowChange", false);
        });
    },
    pushdata() {
      var that = this;
      that.loading = true;
      that.$axios
        .get("/api2/business/getCheckOrderInfo/" + this.checkOrder.id, {})
        .then(function (response) {
          that.checkOrder = response.data.data;
          that.value1 = [that.checkOrder.timeStart, that.checkOrder.timeEnd];
          that.loading = false;
        });
    },
    init(item) {
      var that = this;
      console.log("订单子组件调用" + item);
      if (item.checkPersonName) {
        that.loading = true;
        that.ischeck = true;
        that.$axios
          .get("/api2/business/getCheckOrderInfo/" + item.checkOrderId, {})
          .then(function (response) {
            that.checkOrder = response.data.data;
            that.value1 = [that.checkOrder.timeStart, that.checkOrder.timeEnd];
            that.loading = false;
            that.isSchedule = true;
          });
      } else {
        that.checkOrder.checkPersonName = "";
        that.ischeck = false;
        that.isSchedule = false;
      }
      that.checkOrder.homeTypeName = item.homeTypeName;
      that.checkOrder.homeId = item.id;
      that.checkOrder.homeNum = item.homeNum;
      that.checkOrder.homePrice = item.homePrice;
      that.checkOrder.homeDeposit = item.homeDeposit;
      var time=item.time;
      console.log("父组件日期"+time)
      that.value1 = [time, time];
    },

    closeDialog() {
      this.$emit("modelShowChange", false);
    },
    czcloseDialog() {
      this.czshow = false;
    },

    xzcloseDialog() {
      this.xzshow = false;
    },
    /**
     * 格式化函数 ， 给日期格式化
     * date为 new Date()对象， fmt为 'yyyy-MM-dd hh:mm:ss'的格式
     */
    formatDate(date) {
      console.log(date);
      var time = new Date(date).getTime();
      //将时间戳格式转换成年月日时分秒
      var date = new Date(time);
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";

      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      var strDate = Y + M + D;
      console.log("输出内容:", strDate);
      return strDate;
    },
  },
};
</script>
<style scoped>
.name {
  font-size: 17px;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>

